export const tsxSection1 = (
  <div>
    <p>
      Alles begann mit Kindheitserinnerungen und der Freude am Teilen, sei es Zeit oder materielle Dinge. Schon als Kind war ich, Intan, von Liebe und Leidenschaft geprägt und tat so viel Gutes, wie ich selbstlos geben konnte. Nach dem Abschluss meines Bachelorstudiums Anfang 2010 begann sich meine Sichtweise zu verändern. Mir wurde bewusst, dass Überfluss nicht die einzige Voraussetzung ist, um teilen zu können.
    </p>
    <p>
      Auch wenn sich mein Leben im Laufe der Zeit verändert hat, hielt mich das nicht davon ab, weiterhin zu geben. Ich öffnete mein Herz und begann, von dem, was ich hatte, an Waisenhäuser zu spenden, um Bedürftigen zu helfen: den Armen, Witwen, Kindern mit Behinderungen und Waisenkindern in Indonesien. Diese Entscheidung erfüllte mich mit tiefer Zufriedenheit, eine Entscheidung, die ich keine Sekunde bereut habe. Obwohl ich selbst mit begrenzten Mitteln teilte, schenkte mir dieses Geben eine überwältigende Freude im Herzen.
    </p>
    <p>
      Ich entschied mich, nicht darauf zu warten, eines Tages großen Reichtum zu besitzen, um helfen zu können. Denn das Wichtigste ist: Ob ich wenig oder viel habe, ich kann mit Freude geben.
    </p>
    <p>
      Korinther 9,7 <br />
      „Jeder gebe, wie er es sich im Herzen vorgenommen hat, nicht widerwillig oder gezwungen; denn einen fröhlichen Geber hat Gott lieb.“
    </p>
  </div>
);
